var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"abs wh100p orange lighten-4"}),_c('v-container',[_c('div',{staticClass:"psf-center"},[_c('h1',{staticStyle:{"font-size":"4vm","white-space":"nowrap","text-align":"center"}},[_vm._v("台灣好行滿意度調查問卷建檔平台")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }